import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
const OatEditActivepopMain = () => {



  let EditData = JSON.parse(localStorage.getItem("EditOatActiveData"));
  const [Active, setActive] =useState(" ")

  let company_Name = EditData.map((item) => item.company_Name);

  let company_Id = EditData.map((item) => item.company_Id);
  let Company_Id = company_Id[0]

  let personname = EditData.map((item) => item.personname);
  let status= EditData.map((item) => item.status);
  function ActiveEntity(){


    //var Company_Id = document.getElementById("Company_Id_Oat").value;
    var Reason = document.getElementById("InActiveReason_oat").value;
   // var Name =document.getElementById("Person_oat").value

    if(!Reason){

      document.getElementById("ErrA").innerHTML="Reason Required"
    }

    else{

      document.getElementById("ErrA").innerHTML="  "
    }

    if(Active===0){

      var Action =0
     }
     else if(Active===1){
      var Action= 1

     }

     else{
        var Action=1

     }

    if(Reason){
    
    const body =
    {
      companyId:Company_Id,
      reason:Reason,
      status:Action,
      superAdminId:"3dd01fa3-78f3-4080-bb1c-651b9af8389a"

     }
  console.log(body,"dfvbn")

     axios({
      method:"POST",
      url :`${BASE_URL}/OatMain/InActiveStatus`,
      data:body, 
      headers: {
           "Content-Type": "application/json",
           
       }     
   }) 

  .then((response) =>{
  console.log(response.data);


  if(response.data.status === "Success"){
    
       //toast.success("InActivated " +Name)
      
    //alert("InActivated ")
    document.getElementById("ActiveSuccess-Oat").style.display="block"
       setTimeout(() => {
       
        window.location.href="/?#/OatEntity"
        document.getElementById("ActiveSuccess-Oat").style.display="none"
       }, 2000);
     }

     else if(response.data.status === "SameStatus"){
     // toast.info("Not Changed" +Name)
     //alert("Not Changed")
     document.getElementById("NotChange-Oat").style.display="block"
    
      setTimeout(() => {
      
        window.location.href="/?#/OatEntity"
        document.getElementById("NotChange-Oat").style.display="none"
       
      }, 2000);

     }


})
.catch(error => {
 console.log(error);
 alert("failed !")


})
 
}

    
    }
  return (
    <>
    <>
    <div  className='oat-addmain'>

<ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
          
    
          <div className="oat-addgrid-layout">
    <div className="oat-addmain-top">
        <div className='oat-addmain-back'>
          
        </div> 
          
           <span className='OatTitle'>
    <span>EDIT ACTIVE</span></span>
    <div className='oat-addmain-back'>
      <Link to="/OatEntity"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     </div>
 </div>
    {/* Alert Messages */}
   {/* Active success */}
    
   <div className='oat-toastpop-fade' id="ActiveSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Inactivated successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
 
   {/* NotChange success */}
    
   <div className='oat-toastpop-fade' id="NotChange-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-info Oatalert-white rounded" id="InfoPopOat">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-info-circle"></i></div>
    <strong style={{color:"#31708f"}}>Info</strong>&nbsp;Not Changed!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>  

 <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"-50px",border:"1px solid rgb(255 255 255)"}}>
      {/* <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT ACTIVE</h4>
        <button type="button" className="close" onClick={closeActiveEditForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div> */} 
      <form  id="oateditform" onSubmit={ActiveEntity} style={{boxShadow:"3px 2px 5px #464343, 12px 16px 5px #ffffff"}}>
      <div className="modal-body mx-3">
        <br></br><br></br>
      <div className="md-form mb-5">
        <label id="sectionlable">Entity Name</label>
     
         <input type="text" defaultValue={company_Name} readOnly/>
         <input type="text" defaultValue={company_Id} style={{display:"none"}}id="Company_Id_Oat" readOnly/>
        </div>
        
        <div className="md-form mb-5">
        <label id="sectionlable">Contact Person</label> 
          <input type="text"  id="Person_oat"  defaultValue={personname} readOnly/>
        
        </div> 
        <div className="md-form mb-5">
        <label id="sectionlable">Inactive Reason</label> 
          <input type="text" id="InActiveReason_oat" />
          <span id="ErrA" className='error'></span>
        </div> 

        <div className="md-form mb-3">

  


         
         <center>
          <input type="checkbox" id="oatactiveswitchA"
              className="Activecheckbox"  onChange={()=>setActive(0)}/>
            <label for="oatactiveswitchA" className="oattoggleactive">
       

           <p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


          </label>

          </center>
             



</div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>
    </div>
    </>
    </>
  )
}

export default OatEditActivepopMain

